import { render, staticRenderFns } from "./OM.vue?vue&type=template&id=029450fc&scoped=true"
import script from "./OM.vue?vue&type=script&lang=js"
export * from "./OM.vue?vue&type=script&lang=js"
import style0 from "./OM.vue?vue&type=style&index=0&id=029450fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029450fc",
  null
  
)

export default component.exports